import { Box } from "@mui/material"
import { ReactNode } from "react"

type MainLayoutProps = {
  children: ReactNode
}

const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: 3,
        ml: { md: "220px", xs: 0 },
        mt: "100px",
        backgroundColor: "#F8F9FC",
      }}
    >
      {children}
    </Box>
  )
}

export default MainLayout;
